import { render } from "./setMealModel.vue?vue&type=template&id=7604ded4"
import script from "./setMealModel.vue?vue&type=script&lang=js"
export * from "./setMealModel.vue?vue&type=script&lang=js"

import "./setMealModel.vue?vue&type=style&index=0&id=7604ded4&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__